import precise from '../modules/precise';
import VSVC from './data/vesselSVCConstants';

function getVesselFee(options) {
  const { shouldChargeVesselCountyFees } = options;
  const BaseFee = Number(options.BaseFee);
  const BFfee = Number(options.BFfee);
  const cmm = Number(options.cmm);
  const r17 = Number(options.pipe.r17);
  const r16 = Number(options.pipe.r16);
  const rset = Number(options.pipe[`r${options.monthsFromNow}`]);

  let vscf = 0;
  let total = 0;

  // Just add up all the Vessel SVC Fees
  const VSsvc = Object.keys(VSVC).reduce((acc, n) => VSVC[n] + acc, 0);

  if (VSsvc !== 4.75) {
    throw new Error('VSSvc should be 4.75 per 9/01/14 fees');
  }

  if (shouldChargeVesselCountyFees) {
    vscf = rset * 0.50; // adjusted 2/11/10; // verified formula by email with Cyndi Collins at DMV 6/13/08 for monthly portion of variable vscf
    if (vscf < 1.75) {
      vscf = 1.75;
    }

    // Note that this this throws the calculations off.
    // It should be removed, but is here temporarily for
    // demonstration, evaluation and comparison.
    // if (vscf >= 1.75 || vscf < 1.75) {
    //   vscf = 1.75;
    // }
  }

  if (r17 === 5.50) {
    // if vessel is 1-11 ft
    total = rset + VSsvc + BFfee + vscf + cmm;
  } else if (r17 !== 5.50 && r17 !== 0) {
    total = rset + VSsvc + BFfee + vscf + cmm;
  } else if (r17 !== 0) {
    // If not 1 - 11 Ft or Exempt
    total = BaseFee + VSsvc + BFfee + vscf + cmm;
  }

  if (r16 === 5 && ((r17 === 0) || (r17 === 2))) {
    // for exempt & antique vessels including commercial // 5.75
    total = 3.75 + BFfee + cmm;
  }

  return precise(total);
}

export default getVesselFee;
